import { render, staticRenderFns } from "./ShokurekishoPreview.vue?vue&type=template&id=7b2cb3a4"
import script from "./ShokurekishoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports